"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageInputStatus = exports.PageInputKind = void 0;
var PageInputKind;
(function (PageInputKind) {
    PageInputKind["Checkbox"] = "checkbox";
    PageInputKind["Date"] = "date";
    PageInputKind["Number"] = "number";
    PageInputKind["Radio"] = "radio";
    PageInputKind["Select"] = "select";
    PageInputKind["Signature"] = "signature";
    PageInputKind["Text"] = "text";
    PageInputKind["Timestamp"] = "timestamp";
})(PageInputKind = exports.PageInputKind || (exports.PageInputKind = {}));
var PageInputStatus;
(function (PageInputStatus) {
    PageInputStatus["Disabled"] = "disabled";
    PageInputStatus["Error"] = "error";
    PageInputStatus["Optional"] = "optional";
    PageInputStatus["Required"] = "required";
    PageInputStatus["Success"] = "success";
})(PageInputStatus = exports.PageInputStatus || (exports.PageInputStatus = {}));
//# sourceMappingURL=types.js.map